// extracted by mini-css-extract-plugin
export default {"root":"G7hcgnVuky6SVXGZO_lJ","name":"D7he9HnoytL07Qcky1bA","type":"r5yGiaayRA5aLkypqrRV","description":"fiVLfyvUsk195dOlLIw4"};